import axiosInstance from "../libs/axiosInstance";

// Create a new department
export const createDepartment = async (departmentData) => {
  try {
    const response = await axiosInstance.post('/course_management/departments/', departmentData);
    return response.data;
  } catch (error) {
    console.error('Error creating department:', error);
    throw error;
  }
};

// Get all departments
export const getDepartments = async () => {
  try {
    const response = await axiosInstance.get('/course_management/departments/');
    return response.data;
  } catch (error) {
    console.error('Error fetching departments:', error);
    throw error;
  }
};

// Update a department
export const updateDepartment = async (departmentId, departmentData) => {
  try {
    const response = await axiosInstance.put(`/course_management/departments/${departmentId}/`, departmentData);
    return response.data;
  } catch (error) {
    console.error('Error updating department:', error);
    throw error;
  }
};

// Delete a department
export const deleteDepartment = async (departmentId) => {
  try {
    await axiosInstance.delete(`/course_management/departments/${departmentId}/`);
  } catch (error) {
    console.error('Error deleting department:', error);
    throw error;
  }
};
